// src/features/auth/components/RegistrationComplete.tsx

import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface RegistrationCompleteProps {
  email: string;
}

export const RegistrationComplete: React.FC<RegistrationCompleteProps> = ({ email }) => {

  return (
    <Box 
      sx={{ 
        textAlign: 'center',
        py: 4
      }}
    >
      {/* Logo/Icon */}
      <Box 
        sx={{ 
          mb: 3,
          width: '160px',
          justifySelf: 'center'
        }}
      >
        <img
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} 
          src={`${process.env.REACT_APP_HOME_URL}/wp-content/uploads/2026/02/be7f292740925e2dba8d7585a76b26e16bec7f2a.png`} alt="" 
        />
      </Box>

      {/* Heading */}
      <Typography 
        variant="h4" 
        sx={{ 
          mb: 2,
          color: '#E91E63',
          fontWeight: 'normal'
        }}
      >
        Thank you for Registration
      </Typography>

      {/* Message */}
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ mb: 1 }}
      >
        An email has been sent to the following address
      </Typography>
      
      <Typography 
        variant="body1" 
        sx={{ 
          mb: 2,
          fontWeight: 'medium'
        }}
      >
        {email}
      </Typography>

      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ mb: 4 }}
      >
        Please follow the instructions in the email to complete the creation of your user account.
      </Typography>

      {/* <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ mb: 1 }}
      >
        If you have not received the confirmation email, please{' '}
        <Typography
          component="span"
          onClick={handleResendEmail}
          sx={{
            color: resendStatus === 'sent' ? 'success.main' : 'primary.main',
            cursor: resendStatus === 'sending' ? 'wait' : 'pointer',
            textDecoration: 'underline',
            pointerEvents: resendStatus === 'sending' ? 'none' : 'auto',
          }}
        >
          {resendStatus === 'sending' ? 'Sending...' : resendStatus === 'sent' ? 'Email sent!' : 'click here'}
        </Typography>
        {' '}to receive a new one.
        {resendStatus === 'error' && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            Failed to resend email. Please try again.
          </Typography>
        )}
      </Typography> */}

      {/* Button */}
      <Button
        variant="contained"
        onClick={() => window.location.href = process.env.REACT_APP_HOME_URL || '/'}
        sx={{
          mt: 3,
          bgcolor: '#000',
          color: '#fff',
          '&:hover': {
            bgcolor: '#333',
          },
          textTransform: 'none',
          px: 4,
          py: 1.5
        }}
      >
        Return to Homepage
      </Button>
    </Box>
  );
};